import type { RoleTerms } from "../constants/platformTerms";

export function isTermsComplete(
  terms: RoleTerms,
  masterAccepted: boolean,
  conflictAccepted = false,
): boolean {
  return masterAccepted && (!terms.conflictOfInterest || conflictAccepted);
}
